var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('status-icon',{attrs:{"status":_vm.status,"size":_vm.size,"statuses":_vm.statuses}})}
var staticRenderFns = []

export { render, staticRenderFns }